module.exports = __webpack_public_path__ + "images/CreditCard1095d65954d165c2eb1ad885ec12eb0d.svg";